import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import ExtraChargesActions, { extraChargesActionTypes } from '../../actions/configurations/extraChargesAction';
import ExtraChargesServices from '../../services/configurations/extraChargesService';

/**
 * @param action
 */

function* _createCharge(action) {
  try {
    yield put(ExtraChargesActions.createChargeLoading(true));
    const { payload } = action;
    const extraCharges = yield ExtraChargesServices.createCharge(payload);
    if (!extraCharges.success) {
      notification.open({
        type: 'error',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(ExtraChargesActions.createChargeLoading(false));
  } catch (error) {
    yield put(ExtraChargesActions.createChargeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* createCharge() {
  yield takeLatest(extraChargesActionTypes.CREATE_EXTRA_CHARGES.REQUEST, _createCharge);
}

function* _updateCharge(action) {
  try {
    yield put(ExtraChargesActions.updateChargeLoading(true));
    const { payload } = action;
    const extraCharges = yield ExtraChargesServices.updatCharge(payload);
    if (!extraCharges.success) {
      notification.open({
        type: 'error',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(ExtraChargesActions.updateChargeLoading(false));
  } catch (error) {
    yield put(ExtraChargesActions.updateChargeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* updateCharge() {
  yield takeLatest(extraChargesActionTypes.UPDATE_EXTRA_CHARGES.REQUEST, _updateCharge);
}

/**
 *
 * @param action
 */

function* _getCharges(action) {
  try {
    yield put(ExtraChargesActions.getChargeLoading(true));
    const { orgId,entityName } = action;
    const extraCharges = yield ExtraChargesServices.getCharges(orgId,entityName);
    if (!extraCharges.success) {
      notification.open({
        type: 'error',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(ExtraChargesActions.getChargesSuccess(extraCharges?.data));
      if (action.callback) {
        action.callback(extraCharges?.data);
      }
    }
    yield put(ExtraChargesActions.getChargeLoading(false));
  } catch (error) {
    yield put(ExtraChargesActions.getChargeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */

function* getCharges() {
  yield takeLatest(extraChargesActionTypes.GET_EXTRA_CHARGES.REQUEST, _getCharges);
}

/**
 * @param action
 */

function* _deleteCharge(action) {
  try {
    yield put(ExtraChargesActions.deleteChargeLoading(true));
    const { payload } = action;
    const extraCharges = yield ExtraChargesServices.deleteCharge(payload);
    if (!extraCharges.success) {
      notification.open({
        type: 'error',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: extraCharges?.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(extraCharges.seller);
      }
    }
    yield put(ExtraChargesActions.deleteChargeLoading(false));
  } catch (error) {
    yield put(ExtraChargesActions.deleteChargeLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* deleteCharge() {
  yield takeLatest(extraChargesActionTypes.DELETE_EXTRA_CHARGES.REQUEST, _deleteCharge);
}

/**
 *
 */
export default function* ExtraChargesSaga() {
  yield all([
    createCharge(), updateCharge(), getCharges(), deleteCharge(),
  ]);
}
